import images from "@/assets/images";
import Button from "@/components/Button";
import React from "react";
import classnames from "classnames";
import { Popover } from "antd";
import { clickGeneralDownload } from "@/report";
import { useAnimationTime } from "@/hooks";
import TiltedCard from "@/components/TiltedCard";
import { downloadFile } from "@/utils";
import Constants from "@/constants";

interface IIOSAndHDProps {
  isBigScreen: boolean;
}
const IOSAndHD: React.FC<IIOSAndHDProps> = ({ isBigScreen }) => {
  if (isBigScreen)
    return (
      <div className="flex h-full items-center justify-between">
        <Left isBigScreen={isBigScreen} className="u-max-w-[575px] ml-[100px] mr-[5vw] shrink-0" />
        <Right className="mr-[14vw] min-w-[505px]" />
      </div>
    );

  return (
    <div className="mx-[106px] mt-[48px] flex flex-col items-center justify-between">
      <Left className="px-auto mb-[40px]" />
      <Right className="px-auto min-w-[680px]" />
    </div>
  );
};

interface ILeftProps {
  className?: string;
  isBigScreen?: boolean;
}
const Left: React.FC<ILeftProps> = ({ className, isBigScreen }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <div
      className={classnames(
        "content-wrap-animation",
        className,
        !isAnimationFirst && "!ani-delay-0",
      )}
    >
      <div className={classnames("title-animation", !isAnimationFirst && "!ani-delay-0")}>
        <p className="max-text-[42px] max-leading-[42px] text-[#FFF]">虎牙直播移动端</p>
        <p className="max-text-[52px] max-leading-[52px] mt-[20px] text-[#fff]">
          蓝光直播赛事随时看
        </p>
      </div>

      <div
        className={classnames(
          "download-button-animation u-max-w-[232px] mt-[32px]",
          !isAnimationFirst && "!ani-delay-300",
        )}
      >
        <Popover
          className="w-content"
          content={<PopoverContent />}
          trigger="hover"
          placement={isBigScreen ? "bottomLeft" : "rightBottom"}
        >
          {/* 必须包个div才行 */}
          <div>
            <Button className="bg-primary u-max-w-[200px] u-max-h-[52px]">
              <p className="max-text-[18px] font-[500] text-[#0B0B0B]">立即下载</p>
            </Button>
          </div>
        </Popover>
      </div>
    </div>
  );
};

const PopoverContent = () => {
  return (
    <div className="flex h-[142px] w-[340px] rounded-[4px] bg-[#292929] p-[16px]">
      <img src={images.qrcode} className="mr-[12px] h-[110px] w-[110px]" />
      <div className="flex flex-1 flex-col justify-between">
        <div>
          <p className="text-[14px] font-[500] leading-[20px] text-[#fff]">手机或平板扫码下载</p>
          <p className="mt-[8px] text-[12px] font-[500] leading-[17px] text-[#FFFFFF99]">
            或手动下载安装包
          </p>
        </div>
        <div className="flex w-full items-center justify-between">
          <div
            className="flex cursor-pointer"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.APP_IOS);
              clickGeneralDownload({
                button_name: "iOS安装包",
                product_name: "1",
              });
            }}
          >
            <img src={images.iconDown} className="mr-[4px] h-[16px] w-[16px]" />
            <p className="text-[13px] leading-[18px] text-[#ffe44d]">iOS安装包</p>
          </div>
          <div
            className="flex cursor-pointer"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.APP_ADR);
              clickGeneralDownload({
                button_name: "安卓安装包",
                product_name: "1",
              });
            }}
          >
            <img src={images.iconDown} className="mr-[4px] h-[16px] w-[16px]" />
            <p className="text-[13px] leading-[18px] text-[#ffe44d]">安卓安装包</p>
          </div>
        </div>
      </div>
    </div>
  );
};

interface IRightProps {
  className?: string;
}
const Right: React.FC<IRightProps> = ({ className }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <TiltedCard
      className={classnames("product-animation", className, !isAnimationFirst && "!ani-delay-150")}
      imageSrc={images.PC2}
      rotateAmplitude={8}
      scaleOnHover={1.05}
      showMobileWarning={false}
      showTooltip={false}
      displayOverlayContent={false}
    />
  );
};

export default IOSAndHD;
